import WordCloud from './WordCloud';

export default WordCloud;
